<template>
  <p v-if="footer" class="pi-footer">
    <span v-if="footer.asOfText">{{ footer.asOfText }}</span>
    <span v-if="footer.versionText">{{ footer.versionText }}</span>
    <span v-for="item in footer.coverageItems" :key="item">{{ item }}</span>
    <span v-if="footer.partial">Há dados parciais nesta visão</span>
    <router-link class="pi-link" to="/product-intelligence/status">Catálogo e status da coleta</router-link>
  </p>
</template>

<script>
import { combineEnvelopes } from "./piRequests.js";

export default {
  name: "pi-page-footer",
  props: {
    envelopes: { type: Array, default: () => [] },
    labels: { type: Array, default: () => [] },
  },
  computed: {
    footer() {
      return combineEnvelopes(this.envelopes, this.labels);
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin: 16px 0 0;
  padding-top: 10px;
  border-top: 1px solid #eef0f2;
  font-size: 11px;
  color: #6b7280;
}

.pi-footer .pi-link {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piPageFooter.vue